<shared-toolbar title="Asignaciones de parqueo" [subtitle]="pageSubTitle">
  <shared-search-field (inputValue)="fielInput = $event" [data]="dataSource" />
</shared-toolbar>

<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content class="overflow-y-hidden overflow-x-scroll">
    <table mat-table class="w-full" [dataSource]="dataSource" matSort>
      <!-- Date Column -->
      <ng-container matColumnDef="date" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Fecha de asignación
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.parkingAssignmentDTO.createDate }}
        </td>
      </ng-container>

      <!-- User Column -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuario</th>
        <td mat-cell *matCellDef="let element">
          {{ element.userName }}
        </td>
      </ng-container>
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
        <td mat-cell *matCellDef="let element">
          {{ element.firstName }}
        </td>
      </ng-container>
      <!-- User Column -->
      <ng-container matColumnDef="lastname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Apellido</th>
        <td mat-cell *matCellDef="let element">
          {{ element.lastName }}
        </td>
      </ng-container>
      <!-- User Column -->
      <ng-container matColumnDef="since">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Fecha incio libre
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.parkingAssignmentDTO.vacancyStartDate }}
        </td>
      </ng-container>
      <!-- User Column -->
      <ng-container matColumnDef="until">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Fecha final libre
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.parkingAssignmentDTO.vacancyEndDate }}
        </td>
      </ng-container>
      <!-- User Column -->
      <ng-container matColumnDef="place">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Parqueo</th>
        <td mat-cell *matCellDef="let element">
          {{ element.parkingAssignmentDTO.workplaceResponseDTO.name }}
        </td>
      </ng-container>
      <!-- User Column -->
      <ng-container matColumnDef="level">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nivel</th>
        <td mat-cell *matCellDef="let element">
          {{
            element.parkingAssignmentDTO.workplaceResponseDTO.floorResponseDTO
              .name
          }}
        </td>
      </ng-container>
      <!-- User Column -->
      <ng-container matColumnDef="building">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Edificio</th>
        <td mat-cell *matCellDef="let element">
          {{
            element.parkingAssignmentDTO.workplaceResponseDTO.floorResponseDTO
              .buildingResponse.name
          }}
        </td>
      </ng-container>

      <!-- <ng-container
        class="flex justify-content-center"
        matColumnDef="options"
        stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            color="accent"
            [matMenuTriggerFor]="menu"
            aria-label="Mas opciones">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <a mat-menu-item>
              <mat-icon mat-icon-button color="warn">delete</mat-icon>
              <span>Eliminar</span>
            </a>
          </mat-menu>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">
          No hay resultados para la busqueda: {{ fielInput }}
        </td>
      </tr>
    </table>
    <br />
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
  </mat-card-content>
</mat-card>
